



















import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Icon
  },
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    label: String,
    value: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    testid: String
  }
})
export default class Checkbox extends Vue {
  emit (event: any) {
    this.$emit('change', event)
    this.$emit('input', event.target.checked)
  }
}
